exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  margin-right: 15px; }\n\nbutton {\n  width: 39px;\n  padding: 0;\n  font-size: 12px;\n  line-height: 12px;\n  white-space: nowrap;\n  color: #929292; }\n  button em {\n    position: relative;\n    top: 1px;\n    color: inherit; }\n\nbutton::before {\n  content: '';\n  position: relative;\n  display: inline-block;\n  width: 5px;\n  height: 5px;\n  margin-right: 2px;\n  border: 1px solid #929292;\n  border-width: 0 0 1px 1px;\n  transform: rotate(45deg);\n  transition: all .3s ease; }\n\nbutton:hover::before {\n  border-color: #CC3D3E; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/power-planner/power-planner/src/app/core.module/location-back.component/location-back.component.scss
// module id = ../../../../../src/app/core.module/location-back.component/location-back.component.scss
// module chunks = main